
import { mapGetters } from 'vuex'
import GOODS_TYPE from '@/enum'
import PinyinMatch from 'pinyin-match' // es
import virtualList from '@/components/virtualList/index.vue' // es

export default {
	name: 'appHeaderSearch',
	components: {
		virtualList
	},
	props: {
		ClassName: {
			default: ''
		}
	},
	data() {
		return {
			loading: true,
			firstChar: null, // 字母筛选
			gameCatalogueId: null, // 游戏类型
			typeIndex: null, // 商品类型
			gameData: [], //游戏列表
			searchGameData: [], // 模糊查询列表
			historyData: [],
			gameCate: [
				{
					label: '全部游戏',
					value: null
				},
				{
					label: '端游',
					value: 1
				},
				{
					label: '手游',
					value: 2
				}
			],
			alphabet: [],
			showBack: null,
			topHeader: null,
			search: '',
			gameCateListForAllText: [{ id: null, name: '全部游戏' }]
		}
	},
	computed: {
		...mapGetters({
			gameCateList: 'game/gameCateList',
			goodsTypeCateList: 'game/goodsTypeCateList',
			gameList: 'game/gameList',
			buyGoodsType: 'game/buyGoodsType'
		})
	},
	async asyncData({ route, app }) {
		return {
			BAIDU_URL: process.env.BAIDU_URL + route.path,
			BAIDU_DATE: app.$formattedDateTime()
		}
	},
	async fetch({ store }) {
		await store.dispatch('game/GoodsTypeCateList')
		await store.dispatch('game/GameCateList')
		await store.dispatch('game/GameList')
	},
	methods: {
		// 选中
		gotoPage(item) {
			this.$emit('searchClickData', item)
		},
		getGoodsType(item) {
			this.typeIndex = item.id
			this.getHistoryList(item.id)
			this.getGameList()
		},
		// 游戏类型栏目
		getGameDataByValue(value) {
			this.gameCatalogueId = value
			this.firstChar = null
			this.getGameList()
		},
		// 通过输入模糊查询游戏列表
		onClickAlphabet(val) {
			if (val === '全部' || val === '') {
				this.firstChar = null
				this.gameData = this.searchGameData
			} else {
				this.firstChar = val
				let arr = []
				this.searchGameData.forEach(item => {
					let matchIndexs = PinyinMatch.match(item.name, val) // 如果匹配到返回 首尾的索引数组，如果匹配不到则返回false
					if (matchIndexs) {
						arr.push(item)
					}
				})
				this.gameData = arr
			}
			// this.getGameList()
		},
		// 通过首字母查询游戏列表 待优化
		onClickGameListS(val) {
			if (val === '全部' || val === '') {
				this.firstChar = null
			} else {
				this.firstChar = val
			}
			this.loading = true
			const data = {
				action: {
					firstChar: this.firstChar,
					gameCatalogueId: this.gameCatalogueId,
					goodsCatalogueId: this.typeIndex
				}
			}
			this.$api.gameAll(data).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.loading = false
				this.gameData = res.data
			})
		},
		// 获取游戏列表
		getGameList() {
			this.loading = true
			const data = {
				action: {
					firstChar: null,
					gameCatalogueId: this.gameCatalogueId,
					goodsCatalogueId: this.typeIndex
				}
			}
			this.$api.gameAll(data).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.loading = false
				this.gameData = res.data
				this.searchGameData = res.data
			})
		},
		// 获取历史游戏列表
		getHistoryList(goodsCatalogueId) {
			// 解决nuxt 找不到windows的问题
			if (process.client) {
				let historyData = JSON.parse(window.localStorage.getItem('HistoryList')) || []
				let _arr = []
				if (!historyData.length) return
				historyData.map(item => {
					this.gameList.map(element => {
						if (item.id === element.id) {
							_arr.push(item)
						}
					})
				})
				this.historyData = _arr.filter(item => item.goodsCatalogueId === this.typeIndex || GOODS_TYPE.ACCOUNT)
			}
		}
	},
	created() {
		// 返回按钮
		this.showBack = this.$route.query.from
	},
	async mounted() {
		for (let i = 0; i < 26; i++) {
			this.alphabet.push(String.fromCharCode(65 + i))
		}
		this.alphabet.unshift('全部')
		this.typeIndex = this.buyGoodsType || (this.goodsTypeCateList[0] && this.goodsTypeCateList[0].id)
		this.getHistoryList()
		await this.$store.dispatch('game/GameCateList')
		this.gameCateListForAllText = this.gameCateListForAllText.concat([...this.gameCateList])
		this.gameData = this.gameList
		this.searchGameData = this.gameList
	}
}
